<div *ngIf="currentUser">

  <table class="table" style="background-color:white;">

    <tr>
      <td style="background-color:brown;color:white;" colspan="2">  My Profile </td>
      <td style="text-align: right;background-color: brown;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
    </tr>
  </table>



  <div class="container">

    <h5 (click)="editUserProfile(2)" *ngIf="edit" style="text-align:right;text-decoration:underline;">Back To Profile</h5>
    <div class="row">
     

      <div class="col-9" *ngIf="!edit">
        <!--<div class="row">
          <div class="col-6">
            <p>First Name :   {{currentUser.firstname}}</p>
          </div>
          <div class="col-6">
            <p>Last Name :   {{currentUser.lastname}}</p>
          </div>

        </div>-->
        <div class="row">
          <div class="col-6">
            <p style="font-weight:bold;">Email ID :   {{currentUser.email}}</p>
          </div>
          <div class="col-6">
            <p style="font-weight:bold;">Mobile Number :  {{currentUser.MobileNo}}</p>
          </div>



        </div>
        <!--<div class="row">
          <div class="col-6">
            <p *ngIf="currentUser.emailConfirmed==0">Email ID Status  : <span style="color:red">Not Verified</span></p>
            <p *ngIf="currentUser.emailConfirmed==1">Email ID Status  : <span style="color: forestgreen">Verified</span></p>
          </div>
          <div class="col-6">
            <p *ngIf="currentUser.mobileotpstatus==1">Mobile No. Status  : <span style="color:forestgreen">Verified</span></p>

            <p *ngIf="currentUser.mobileotpstatus==0">
              Mobile No. Status  : <span style="color:red">Not Verified</span>
            </p>
          </div>
        </div>-->
        <!--<div class="row">
          <div class="col-6">
            <p *ngIf="currentUser.kyc_docStatus==0">KYC Status : <span style="color:red">Not Verified</span></p>
            <p *ngIf="currentUser.kyc_docStatus==1">KYC Status : <span style="color:red">Pending</span></p>
            <p *ngIf="currentUser.kyc_docStatus==2">KYC Status : <span style="color:forestgreen">Verified</span></p>
            <p *ngIf="currentUser.kyc_docStatus==3">KYC Status : <span style="color:red">Rejected</span></p>
            <p *ngIf="currentUser.kyc_docStatus==4">KYC Status : <span style="color:red">Your document is Not Ok</span></p>

          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <p> Daily Withdrawal Limit :   {{withdrawallimit}}</p>
          </div>
          <div class="col-6" *ngIf="currentUser.category == 'MERCHANT'">
            <p>Company Name :   {{companyname}}</p>
          </div>

        </div>-->



      </div>
      <!--<div class="col-9" *ngIf="edit">
        <div class="row">
          <form (ngSubmit)="updateProfile(editProfileDetail.value)" [formGroup]="editProfileDetail">


            <div class="row">
              <div class="col-5">
                <mat-form-field>
                  <input matInput placeholder="First Name" formControlName="FirstName" maxlength="15" required />
                  <mat-error *ngIf="submitted && f.FirstName?.errors?.required">
                    Enter First Name
                  </mat-error>

                </mat-form-field>
              </div>
              <div class="col-5">
                <mat-form-field>
                  <input matInput placeholder="Last Name" formControlName="LastName" maxlength="15" required />

                  <mat-error *ngIf="submitted && f.LastName?.errors?.required">
                    Enter Last Name
                  </mat-error>

                </mat-form-field>

              </div>
              <div class="col-2">
                <button type="submit" mat-raised-button color="primary" style="margin-top: 11px;">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>-->
    </div>
  </div>
</div>

